$('.cat-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1200,
            settings: { slidesToShow: 4 }
        },
        {
            breakpoint: 992,
            settings: { slidesToShow: 3 }
        },
        {
            breakpoint: 768,
            settings: { slidesToShow: 2 }
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 2 }
        }
    ]
});

$('.testi-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: { slidesToShow: 4 }
        },
        {
            breakpoint: 992,
            settings: { slidesToShow: 3 }
        },
        {
            breakpoint: 768,
            settings: { slidesToShow: 2 }
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 1 }
        }
    ]
});


$('.review_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,

    prevArrow: '<button class="slick-prev">←</button>',
    nextArrow: '<button class="slick-next">→</button>',

    responsive: [
        {
            breakpoint: 1200,
            settings: { slidesToShow: 4 }
        },
        {
            breakpoint: 992,
            settings: { slidesToShow: 2 }
        },
        {
            breakpoint: 768,
            settings: { slidesToShow: 1 }
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 1 }
        }
    ]
});



document.addEventListener("DOMContentLoaded", function() {
const videoItems = document.querySelectorAll('.video-item');
const lightbox = document.getElementById('lightbox');
const lightboxVideo = document.getElementById('lightbox-video');
const closeBtn = document.querySelector('.close');

videoItems.forEach(item => {
  item.addEventListener('click', () => {
    const videoURL = item.getAttribute('data-video');
    lightboxVideo.src = videoURL;
    lightboxVideo.load();
    lightboxVideo.play();
    lightbox.style.display = "flex";
  });
});

closeBtn.addEventListener('click', () => {
  lightbox.style.display = "none";
  lightboxVideo.pause();
  lightboxVideo.src = "";
});

lightbox.addEventListener('click', (e) => {
  if (e.target === lightbox) {
    lightbox.style.display = "none";
    lightboxVideo.pause();
    lightboxVideo.src = "";
  }
});
});

$(window).scroll(function(){
  var sticky = $('.sticky'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});

document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll(".color-swatch").forEach(function(swatch) {

    swatch.addEventListener("click", function() {

      let newImage = this.getAttribute("data-image");
      let productCard = this.closest(".product-card");
      let mainImage = productCard.querySelector(".product-img img:first-child");

      if (mainImage) {
        mainImage.src = newImage;
      }

      // active class toggle
      productCard.querySelectorAll(".color-swatch").forEach(s => s.classList.remove("active"));
      this.classList.add("active");

    });

  });

});

AOS.init({
  duration: 1200,
})


//   $(document).ready(function(){

//   /* INIT SLICK */
//   $('.product-main').slick({
//     slidesToShow: 1,
//     arrows: true,
//     infinite: false
//   });

//   $('.product-thumbs').slick({
//     slidesToShow: 4,
//     vertical: true,
//     focusOnSelect: true,
//     arrows: false,
//     infinite: false,
//     asNavFor: '.product-main'
//   });

// });
